import {
  FAIL_REQUEST,
  MAKE_REQUEST,
  UPDATE_ISSUCCESS,
  SET_PASSWORD,
  LOGIN_PROCESS,
  SET_INVALID_USER,
  LOGIN_PROCESS_FOR_GMAIL,
  SET_ERROR_MESSAGE,
  OTP_SENT,
  OTP_VERIFIED,
  UPDATE_OTP_PROCESSED,
  PROCESSS_LOGOUT,
  OTP_RESENT,
  OTP_SENT_FOR_LOGIN_BY_OTP,
} from "../actions/adminAuthActions/actionTypes";

const initialObject = {
  loading: false,
  message: "",
  totalCount: 0,
  isSuccess: false,
  isDuplicateUser: "null",
  isOtpSend: false,
  userList: [],
  userData: null,
  errorMessage: "",
  isOtpProcessed: false,
  variant: "",
  email: "",
  otp: null,
  isOtpVerifiedSuccess: false,
  isSetPassword: false,
  isLogInSuccess: false,
  isTimerOn: true,
  isInValidUser: false,
  otpMessage: "",
  contactList: [],
};

export const adminAuthReducer = (state = initialObject, action) => {
  switch (action.type) {
    case MAKE_REQUEST:
      return {
        ...state,
        loading: true,
        isOtpProcessed: false,
      };
    case FAIL_REQUEST:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case UPDATE_ISSUCCESS:
      return {
        ...state,
        isSuccess: action.payload,
        isOtpProcessed: false,
        isOtpVerifiedSuccess: false,
      };
    case SET_PASSWORD:
      return {
        ...state,
        message: action.payload.message,
        isSuccess: action.payload.success,
        loading: false,
        isOtpProcessed: true,
        isOtpVerifiedSuccess: action.payload.success,
        isSetPassword: false,
      };
    case LOGIN_PROCESS:
      return {
        ...state,
        isLogInSuccess: action.payload.success,
        loading: false,
        isLogInProcessed: true,
        isSuccess: action.payload.success,
        message: action.payload.message,
        isOtpProcessed: false,
        userData: action.payload.userData,
      };
    case LOGIN_PROCESS_FOR_GMAIL:
      return {
        ...state,
        isLogInSuccess: action.payload.success,
        loading: false,
        isLogInProcessed: true,
        isSuccess: action.payload.success,
        message: action.payload.message,
        userData: action.payload.userData,
      };

    case SET_INVALID_USER:
      return {
        ...state,
        isInValidUser: action.payload,
      };

    case SET_ERROR_MESSAGE:
      console.log("message", action);
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case OTP_SENT:
      return {
        ...state,
        errorMessage: action.payload.message,
        isSuccess: action.payload.success,
        message: action.payload.message,
        variant: action.payload.variant,
        isOtpProcessed: true,
        loading: false,
        email: action.payload.email,
        isSetPassword: action.payload.isSetPassword,
        isLogInProcessed: true,
        isTimerOn: true,
      };

    case OTP_SENT_FOR_LOGIN_BY_OTP:
      return {
        ...state,
        errorMessage: action.payload.message,
        isSuccess: action.payload.success,
        message: action.payload.message,
        variant: action.payload.variant,
        isOtpProcessed: true,
        loading: false,
        email: action.payload.email,
        isSetPassword: false,
        isLogInProcessed: true,
        isTimerOn: true,
      };

    case OTP_RESENT:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        isSuccess: action.payload.success,
        isOtpProcessed: true,
        isSetPassword: action.payload.isSetPassword,
        isTimerOn: true,
      };
    case OTP_VERIFIED:
      return {
        ...state,
        isOtpVerifiedSuccess: action.payload.success,
        isSuccess: false,
        isOtpProcessed: true,
        data: action.payload.data,
        message: action.payload.message,
        loading: false,
        userData: action.payload.userData,
      };
    case UPDATE_OTP_PROCESSED:
      return {
        ...state,
        isOtpProcessed: action.payload,
        isOtpVerifiedSuccess: false,
        isLogInProcessed: false,
      };
    case PROCESSS_LOGOUT:
      return {
        ...state,
        isOtpProcessed: false,
        loading: false,
        isOtpVerifiedSuccess: false,
        isSetPassword: false,
        isLogInSuccess: false,
        isSuccess: false,
        isLogInProcessed: false,
      };
    default:
      return state;
  }
};
